export const BASE_PATH = process.env.PUBLIC_URL
export var ENV = process.env.REACT_APP_APP_ENV
export var API_URL = process.env.REACT_APP_API_URL
export var UI_URL = process.env.REACT_APP_UI_URL